module.exports = __webpack_public_path__ + "img/PL10089.c3a4445b.png";